<template>
  <span>
    <div class="col-md-12">
      <div class="table-responsive">
        <table id="dataTableExample" class="table table-hover">
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th>Type</th>
              <th>Measure</th>
              <th>Loading</th>
              <th>Dscharging</th>
              <th>Idle</th>
              <th class="text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            <loading-table :isLoading="isLoading" cols="14"></loading-table>
            <tr v-if="form.vessel_consumptions.length == 0">
              <td colspan="14" class="text-center">No data Found</td>
            </tr>
            <tr
              v-for="(vesselConsumption, ar) in form.vessel_consumptions"
              :key="`vesselConsumption${ar}`"
            >
              <td>{{ ar + 1 }}.</td>
              <td>
                <input
                  v-uppercase
                  type="text"
                  class="form-control"
                  placeholder="Type"
                  v-model="vesselConsumption.type"
                />
              </td>
              <td>
                <input
                  v-uppercase
                  type="text"
                  class="form-control"
                  placeholder="Measure"
                  v-model="vesselConsumption.measure"
                />
              </td>
              <td>
                <input
                  v-uppercase
                  type="text"
                  class="form-control"
                  placeholder="Loading"
                  v-model="vesselConsumption.loading"
                />
              </td>
              <td>
                <input
                  v-uppercase
                  type="text"
                  class="form-control"
                  placeholder="Discharging"
                  v-model="vesselConsumption.discharging"
                />
              </td>
              <td>
                <input
                  v-uppercase
                  type="text"
                  class="form-control"
                  placeholder="Idle"
                  v-model="vesselConsumption.idle"
                />
              </td>

              <td>
                <div class="text-center">
                  <button
                    class="btn btn-danger btn-sm"
                    @click="deleteVesselConsumption(vesselConsumption)"
                    v-if="!vesselConsumption.id"
                  >
                    Delete
                  </button>
                  <button
                    class="btn btn-danger btn-sm"
                    @click="
                      delete_vessel_consumption_data(vesselConsumption.id)
                    "
                    v-else
                  >
                    Delete
                  </button>
                </div>
              </td>
            </tr>
            <tr v-if="form.vessel_consumptions">
              <td
                colspan="14"
                align="center"
                @click="addEmptyVesselConsumptions()"
                style="
                  background-color: #6571ff;
                  color: white;
                  border-radius: 10px;
                  box-shadow: none;
                "
              >
                Add New Row
              </td>
            </tr>
          </tbody>
        </table>
        <!-- /Table -->
      </div>
    </div>
  </span>
</template>

<script type="text/javascript">
import axios from "axios";
export default {
  name: "Vessel2FormWidget",
  props: ["form"],
  emits: ["getData"],
  methods: {
    deleteVesselConsumption(consumption) {
      this.form.vessel_consumptions = this.form.vessel_consumptions.filter(
        (ar) => ar != consumption
      );
    },

    addEmptyVesselConsumptions() {
      this.form.vessel_consumptions.push({
        type: "",
        measure: "",
        loading: "",
        discharging: "",
        idle: "",
      });
    },

    async delete_vessel_consumption_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=vessel_consumptions`);
          this.isLoading = false;
          this.$emit("getData");
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
